import { motion } from 'framer-motion'
import { ArrowRight, ShieldCheck, UserCircle, Users } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'
import { OnboardingLayout } from './OnboardingLayout'

type WelcomeCardProps = {
  onContinue: () => void
}

const highlights = [
  { icon: UserCircle, label: 'Set up your profile in seconds' },
  { icon: Users, label: 'Join your team or start your own' },
  { icon: ShieldCheck, label: 'Manage sites, guards, and operations' },
]

export function WelcomeCard({ onContinue }: WelcomeCardProps) {
  return (
    <OnboardingLayout
      step={1}
      totalSteps={2}
      eyebrow="Welcome to NezTrack"
      title="Let's get you set up"
      subtitle="It only takes a minute."
    >
      <motion.ul
        initial={{ y: 12, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="space-y-3"
      >
        {highlights.map(({ icon: Icon, label }) => (
          <li key={label} className="flex items-center gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600">
              <Icon className="h-5 w-5" />
            </span>
            <span className="text-[15px] font-medium text-ink-2">{label}</span>
          </li>
        ))}
      </motion.ul>

      <motion.div
        initial={{ y: 12, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.28 }}
        className="mt-10"
      >
        <Button
          onClick={onContinue}
          className="h-12 w-full rounded-xl bg-indigo-600 text-[15px] font-semibold text-white shadow-md shadow-indigo-600/20 transition-all hover:bg-indigo-700 hover:shadow-lg hover:shadow-indigo-600/30 active:scale-[0.98]"
        >
          Get started
          <ArrowRight className="ml-2 h-5 w-5" />
        </Button>
      </motion.div>
    </OnboardingLayout>
  )
}
